// src/components/auth/SignInButton.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../../auth/authConfig';
import logger from '../../utils/logger';

const SignInButton = () => {
  const { instance } = useMsal();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  // Handle login with redirection behavior
  const handleLogin = async () => {
    setIsLoading(true);
    setError(null);
    logger.log("Login button clicked, starting authentication...");

    try {
      // Use popup on desktop, redirect on mobile.
      // Do NOT clear localStorage here — other tabs listen for isAuthenticated
      // removal and treat it as a logout signal.
      // Do NOT navigate manually after login — AuthContext.validateTokenWithBackend
      // runs automatically once MSAL has the account and handles all routing.
      if (window.innerWidth > 768) {
        try {
          await instance.loginPopup(loginRequest);
          // AuthContext effect picks up the new account and handles routing.
          return;
        } catch (popupError) {
          logger.warn("Popup login failed, falling back to redirect:", popupError);
        }
      }

      await instance.loginRedirect({
        ...loginRequest,
        redirectUri: window.location.origin
      });
    } catch (error) {
      logger.error("Login error:", error);
      setError("Login failed. Please try again.");
      setIsLoading(false);
    }
  };

  return (
    <div>
      <button
        onClick={handleLogin}
        disabled={isLoading}
        className="w-full flex justify-center py-3 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
      >
        {isLoading ? (
          <>
            <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-gray-700" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            Signing in...
          </>
        ) : (
          <>
            <svg className="h-5 w-5 mr-2" viewBox="0 0 24 24" fill="currentColor">
              <path d="M21.5,21.5H12.5V12.5H21.5M21.5,2.5H12.5V11.5H21.5M2.5,21.5H11.5V12.5H2.5M2.5,2.5H11.5V11.5H2.5V2.5Z" />
            </svg>
            Sign in with Microsoft 365
          </>
        )}
      </button>
      
      {error && (
        <div className="mt-3 text-sm text-red-600 text-center">
          {error}
        </div>
      )}
    </div>
  );
};

export default SignInButton;